// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wLwBH","clinicsSelect":"styles_clinicsSelect__3uCrV"};